module.exports = "/img/_/_/_/assets/images/creeper/book/common//31.jpg?8d2de33cd3b4696c92fbada403dd7688";